import { fetcher } from "helpers/fetcher";

import { TDeleteOrganizationReq, TDeleteOrganizationRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteOrganization = async (payload: TDeleteOrganizationReq) => {
  return await fetcher<TDeleteOrganizationRes, TDeleteOrganizationReq["data"]>(
    ENDPOINT.CORPORATION.DELETE_ORGANIZATION,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.CORPORATION.DELETE_ORGANIZATION.version,
        [API_HEADER.CORP_ID]: payload?.idCorp,
      },
    }
  );
};

export const mutationDeleteOrganization = async (
  payload: TDeleteOrganizationReq
) => {
  return (await deleteOrganization(payload)).data;
};

mutationDeleteOrganization._key = (payload: TDeleteOrganizationReq) => [
  ENDPOINT.CORPORATION.DELETE_ORGANIZATION.url,
  payload,
];
